import formatarNumero from "./formatar-numero";

export default function formatarPreco(precoEmCentavos) {
  return formatarNumero(precoEmCentavos / 100, { style: "currency", currency: "BRL" });
}